module.exports = __webpack_public_path__ + "static/img/icon-arrow-left.392d8363.svg";